import React from "react";
import AppCard from "../../../components/AppCard";
import AppCardBody from "../../../components/AppCardBody";
import AppCardHeader from "../../../components/AppCardHeader";

export default function DocsSectionCard({
  title,
  subtitle = null,
  className = "",
  children,
}) {
  return (
    <AppCard className={className}>
      <AppCardHeader title={title} subtitle={subtitle} className="ds-docs-section-card__header" />
      <AppCardBody>{children}</AppCardBody>
    </AppCard>
  );
}
